'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".CheckMark-module_container__avbXI{height:auto;vertical-align:middle;width:3rem;fill:#000}";
var styles = {"container":"CheckMark-module_container__avbXI"};
styleInject["default"](css_248z, '42ff64d2-0401-44a5-82e5-845e3c76ebd0');

exports["default"] = styles;
